<template>
  <div id="app">
    <el-container class="container">
      <el-header :class="{ headerActive: headerActive == 1 }">
        <div class="menu-content">
          <div class="menu-left" @click="logoClick">
            <!-- 导航栏公司logo -->
            <img src="./assets/home_bannar/logo.png" alt="" class="logo-img" />
          </div>
          <div class="menu-right">
            <div class="menu-box">
              <div class="menu-ul">
                <div
                  v-for="(item, index) in menuItems"
                  :key="item.id"
                  class="menu-li"
                  @click.stop="handleClickOne(item)"
                  @mouseenter="submenuShowControl(index)"
                  @mouseleave="clearSubmenuShowControl()"
                >
                  <div
                    :class="{
                      'menu-li-text': true,
                      active: activeIndex === item.visitPath,
                    }"
                  >
                    {{ item.channelName }}
                    <div
                      :class="{ submenuShow: this.submenuIndex == index }"
                      v-if="item.children && item.children.length > 0"
                      class="submenu"
                    >
                      <div
                        class="submenu-item"
                        v-if="item.id == 24 || item.id == 25"
                      >
                        <div class="submenu-item-innerbox">
                          <div
                            class="submenuMainDispaly"
                            v-for="subItem in item.children"
                            :key="subItem.id"
                            @click.stop="handleClickTwo(subItem)"
                            @mouseenter="thirdMenuShowControl(subItem.id)"
                            @mouseleave="clearThirdmenuShowControl()"
                          >
                            <div class="submenu-main-title">
                              {{ subItem.channelName }}
                              <div class="thirdMenu">
                                <div
                                  class="thirdMenu-main-item"
                                  v-for="thirdItem in subItem.children"
                                  :key="thirdItem.id"
                                  @click.stop="handleClickThree(thirdItem)"
                                >
                                  <div class="thirdMenu-main-item-title">
                                    {{ thirdItem.title }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="submenu-item-open"></div>
                      </div>
                      <div
                        class="submenu-item-two"
                        v-if="item.id == 26 || item.id == 27"
                      >
                        <div class="submenu-item-innerbox">
                          <div
                            class="submenuMainDispaly"
                            v-for="subItem in item.children"
                            :key="subItem.id"
                            @click.stop="handleClickTwo(subItem)"
                            @mouseenter="thirdMenuShowControl(subItem.id)"
                            @mouseleave="clearThirdmenuShowControl()"
                          >
                            <div class="submenu-main-title">
                              {{ subItem.channelName }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="menu-search">
              <div
                @click="SearchClick"
                :class="{
                  'serch-icon': true,
                  serchIconActive: headerActive == 1,
                }"
              >
                <el-icon>
                  <Search />
                </el-icon>
              </div>
              <input
                type="text"
                v-model="serachValue"
                @input="removeSpaces"
                :class="{
                  'search-input': true,
                  searchInputActive: headerActive == 1,
                }"
                @keyup.enter="handleSearch"
              />
            </div>
          </div>
        </div>
      </el-header>
      <el-main>
        <div class="right-topUp">
          <div class="right-topUp-top" @click="callUsClick">
            <div class="top-one">
              <img src="./assets/home_bannar/置顶邮箱.svg" alt="" />
            </div>
            <div class="top-line"></div>
            <div class="top-two">
              <img src="./assets/home_bannar/置顶电话.svg" alt="" />
            </div>
          </div>
        </div>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { getnavigation, getFoot } from "../src/api/common";
import { events } from "../src/utils/bus";
import { ElMessage } from "element-plus";

export default {
  name: "app",
  data() {
    return {
      menuItems: [],
      contentListZhbg: [],
      activeIndex: "/", // 默认没有激活的菜单项
      serachValue: "", //搜索框的内容
      headerActive: 0,
      webSiteURl: "",
      submenuIndex: null,
      thirdMenuIndex: null,
      thirdMenuShow: null, //鼠标放在导航时，默认显示二级菜单的第一个
      callUsObj: null,
      rafId: Number,
    };
  },
  created() {
    this.getnavigationData();
    events.on("activeIndex", (value) => {
      //因为informationPersonMap.vue是联系我们，也要点亮一级导航。二级导航和一级导航不一致
      this.activeIndex = value.replace("Map", "");
      this.serachValue = "";
      window.scrollTo({
        top: 0,
      });
    });
    events.on("activeClass", (value) => {
      this.headerActive = value;
    });
    this.getFootData();
  },
  methods: {
    //获取首页所有数据
    getnavigationData() {
      getnavigation().then((res) => {
        this.menuItems = res.data.navigation.map((item) => {
          //if (item.visitPath == "/" || item.visitPath == "/groupDynamics") {
          if (item.visitPath == "/") {
            item.children = null;
          }
          return item;
        });
      });
    },
    //获取底部信息
    getFootData() {
      getFoot().then((res) => {
        this.artSite = res.data.artSite;
        this.webSiteURl = res.data.artSite.webSite;
      });
    },
    //logo点击
    logoClick() {
      this.$nextTick(() => {
        this.$router.push("/");
        this.activeIndex = "/";
        window.scrollTo(
          {
            top: 0,
          },
          1
        );
      });
    },
    //右侧联系我们图标点击
    callUsClick() {
      this.callUsObj = this.menuItems[4].children[4];
      this.$router.push({
        path: this.callUsObj.visitPath,
        query: {
          id: this.callUsObj.parentId,
          //subId: this.callUsObj.id,
        },
        hash: "#" + this.callUsObj.sortNum,
      });
    },

    //一级导航点击
    handleClickOne(item) {
      if (item.linkType == 0) {
        if (item.visitPath == "/") {
          this.$router.push({
            path: item.visitPath,
          });
        } else {
          this.$router.push({
            path: item.visitPath,
            query: {
              id: item.id,
            },
          });
        }
      } else {
        window.open(item.visitPath, "_blank");
      }
      this.activeIndex = item.visitPath;
    },
    // 二级导航点击
    handleClickTwo(subItem) {
      if (subItem.linkType == 0) {
        if (subItem.visitPath == "/companyIntroduction") {
          this.$router.push({
            path: subItem.visitPath,
            query: {
              id: subItem.parentId,
              //subId: subItem.id,
            },
            hash: "#" + subItem.sortNum,
          });
        } else {
          this.$router.push({
            path: subItem.visitPath,
            query: {
              id: subItem.parentId,
              subId: subItem.id,
            },
          });
        }
      } else {
        window.open("/", "_blank");
      }
    },
    // 三级导航
    handleClickThree(thirdItem) {
      if (thirdItem.linkType == 0) {
        this.$router.push({
          path: thirdItem.linkUrl,
          query: {
            id: thirdItem.id,
            channelId: thirdItem.channelId,
          },
        });
      } else {
        window.open(thirdItem.linkUrl, "_blank");
      }
    },

    submenuShowControl(index) {
      this.submenuIndex = index;
      this.thirdMenuShow = 1;
    },
    clearSubmenuShowControl() {
      this.submenuIndex = null;
      this.thirdMenuShow = null;
    },
    thirdMenuShowControl(subItemId) {
      this.thirdMenuIndex = subItemId;
    },
    clearThirdmenuShowControl() {
      this.thirdMenuIndex = null;
    },
    removeSpaces() {
      // 使用正则表达式替换空格
      this.serachValue = this.serachValue.replace(/\s/g, "");
    },
    search(title) {
      if (title == undefined || title == "") {
        ElMessage({
          message: "请输入搜索内容!",
          type: "error",
        });
      } else {
        this.$router.push({
          path: "/search",
          query: {
            title: title,
          },
        });
      }
    },
    SearchClick() {
      this.search(this.serachValue);
    },
    handleSearch() {
      this.search(this.serachValue);
    },
  },
};
</script>

<style lang="scss">
html,
body {
  width: 100%;
  margin: 0;
  font-family: "Microsoft YaHei", "微软雅黑", Source Han Sans, sans-serif;
}

/* 搜索框去除边框 */
input,
button,
select {
  border: 0px;
  /* 设置背景颜色为透明 */
  background-color: transparent;
  /* 去掉外轮廓 */
  outline: none;
}

/* 去掉a的下划线 */
a {
  text-decoration: none;
}

/* 图片的空白间隙 */
img {
  vertical-align: middle;
}

#app {
}

.container {
  display: flex;
  flex-direction: column;
}

.el-header {
  color: #fff;
  text-align: center;
  position: fixed;
  width: 100%;
  height: 100px !important;
  top: 0;
  z-index: 999;
  padding: 0 80px 0 80px !important;
  border-bottom: 2px solid #ffffff;
  background: rgba(255, 255, 255, 1);
  backdrop-filter: blur(24px);
  box-shadow: 0px 2px 10px 0px rgba(5, 39, 83, 0.1);
}
.el-main {
  padding: 0 !important;
  background-color: #ffffff;
  color: #333;
  text-align: center;
  flex: 1;
  overflow-y: auto;
  height: 100vh;
  box-sizing: border-box;
  z-index: 2;
}

//右侧悬浮联系人
.right-topUp {
  position: fixed;
  right: 60px;
  bottom: 100px;
  // bottom: 180px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  transform: scale(0.6);
  .right-topUp-top {
    width: 60px;
    height: 160px;
    border-radius: 30px;
    padding: 30px 10px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.3);
    border: 1px solid #ffffff;
    backdrop-filter: blur(10px);
    box-shadow: 0px 8px 24px 0px rgba(5, 39, 83, 0.1);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    .top-one {
      width: 28px;
      height: 28px;
      overflow: hidden;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .top-line {
      width: 32px;
      height: 1px;
      border-top: 1px solid rgba(194, 194, 194, 0.5);
    }
    .top-two {
      width: 28px;
      height: 28px;
      overflow: hidden;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
.top-one:hover,
.top-two:hover {
  img {
    position: relative;
    left: -200px;
    filter: drop-shadow(#1874ec 200px 0);
  }
}
//menu菜单
.menu-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .menu-left {
    cursor: pointer;
    z-index: 2;
    width: 328px;
    height: 38px;
    .logo-img {
      width: 100%;
      height: 100%;
    }
  }
  .menu-right {
    display: flex;
    align-items: center;
    height: 100%;
    .menu-box {
      display: flex;
      align-items: center;
      height: 100%;
      .menu-ul {
        display: flex;
        align-items: center;
        height: 100%;
        .menu-li {
          height: 100%;
          font-size: 18px;
          color: #3d3d3d;
          padding: 0px 30px;
          line-height: 100px;
          cursor: pointer;
          transition: border-color 0.3s ease;
          .menu-li-text {
            height: 100%;
            border-bottom: 4px solid transparent;
            .submenu {
              position: absolute;
              width: 100vw;
              left: -80px;
              top: 95%;
              line-height: 20px;
              box-sizing: border-box;
              display: flex;

              background: rgb(255, 255, 255);
              overflow: hidden;
              visibility: hidden;
              transition: margin-top 0.5s ease-in-out;

              .submenu-item {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                .submenu-item-innerbox {
                  text-align: left;
                  .submenuMainDispaly {
                    padding: 5px 0px;
                    cursor: pointer;
                    display: flex;
                    align-items: left;
                    .submenu-main-title {
                      font-size: 14px;
                      font-family: "Microsoft YaHei", "微软雅黑",
                        Source Han Sans, sans-serif;
                      font-weight: 600;
                      line-height: 24px;
                      color: #3d3d3d;

                      //三级菜单
                      .thirdMenu {
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 14px;
                        line-height: 28px;
                        color: rgba(61, 61, 61, 0.7);
                        font-weight: 400;
                        .thirdMenu-main-item {
                          margin-right: 50px;
                        }
                        .thirdMenu-main-item:hover {
                          color: #1874ec;
                        }
                      }
                    }
                  }
                  .submenuMainDispaly:hover {
                    .submenu-main-title {
                      color: #1874ec;
                    }
                  }
                }
                .submenu-item-open {
                  width: 100%;
                  height: 10px;
                }
              }
              //无三级菜单
              .submenu-item-two {
                width: 100%;
                .submenu-item-innerbox {
                  display: flex;
                  justify-content: center;
                  .submenuMainDispaly {
                    padding: 30px 40px;
                    cursor: pointer;
                    align-items: left;
                    .submenu-main-title {
                      font-size: 16px;
                      font-family: "Microsoft YaHei", "微软雅黑",
                        Source Han Sans, sans-serif;
                      font-weight: 520;
                      line-height: 24px;
                      color: #3d3d3d;
                    }
                  }
                  .submenuMainDispaly:hover {
                    .submenu-main-title {
                      color: #1874ec;
                    }
                  }
                }
              }
            }
            .submenuShow {
              visibility: visible;
              margin-top: 5px;
              transition: margin-top 0.5s ease-in-out;
            }
          }
          .menu-li-text:hover {
            font-weight: 520;
            color: #1874ec;
          }
          .active {
            border-color: #1874ec;
            font-weight: 520;
            color: #1874ec;
          }
        }
      }
    }
    .menu-search {
      position: relative;
      .search-input {
        font-size: 16px;
        width: 240px;
        height: 40px;
        border-radius: 40px;
        border: 2px solid #dcdcdc;
        padding-left: 40px;
        margin-left: 40px;
        background: rgba(255, 255, 255, 0.1);
        box-sizing: border-box;
      }

      .serch-icon {
        font-size: 18px;
        display: flex;
        align-items: center;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 60px;
        color: #dcdcdc;
      }
    }
  }
}

.headerActive {
  background: rgba(255, 255, 255, 1) !important;
  box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.5);
}

.serchIconActive {
  color: rgba(0, 0, 0, 0.7) !important;
}

.searchInputActive {
  border: 1px solid #000 !important;
  color: rgba(0, 0, 0, 0.7) !important;
}

::v-deep .el-icon {
  width: 14px !important;
  height: 14px !important;
}
</style>


